const ABDM = {
    ACCESS_TOKEN: "ABDM_ACCESS_TOKEN",
    X_TOKEN: "ABDM_X_TOKEN",
    T_TOKEN: "ABDM_T_TOKEN",
    TXN_ID: "ABDM_TXN_ID",
    ABHA_NUMBER: "ABDM_ABHA_NUMBER",
    ABHA_ADDRESS: "ABDM_ABHA_ADDRESS",
    PROFILE: "ABDM_PROFILE"
};
export default ABDM;